import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import ElementUI from "element-ui";
import dayJS from "dayjs";

import "element-ui/lib/theme-chalk/index.css";

import "./assets/common.css";

// 导入API配置
import api from "./api";
 
import 'quill/dist/quill.core.css'  // 富文本
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import "./permission";

import vueMiniPlayer from 'vue-mini-player'
import 'vue-mini-player/lib/vue-mini-player.css'
Vue.use(vueMiniPlayer)

Vue.use(ElementUI);

// 修改 dialog 默认 props
ElementUI.Dialog.props.closeOnClickModal.default = false;
ElementUI.Dialog.props.closeOnPressEscape.default = false;
Vue.config.productionTip = false;
Vue.prototype.$day = dayJS;

// 挂载API到Vue原型
Vue.prototype.$api = api;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
